<template>
  <div id="app">
    <header-component v-if="$route.name != 'root'"></header-component>
    <nav-menu v-if="$route.name != 'root'"></nav-menu>
    <router-view :key="$route.fullPath"/>
    <div class="error" v-if="error">{{error}}</div>
    <div class="success" v-if="success">{{success}}</div>
  </div>
</template>

<script>
import HeaderComponent from "./components/Header"
import NavMenu from "./components/NavMenu"

export default {
  components: {
    HeaderComponent,
    NavMenu
  },
  created: function() {
    this.$store.dispatch("getCustomisations")
  },
  computed: {
    error: function() {
      return this.$store.state.error
    },
    success: function() {
      return this.$store.state.success
    }
  }
}
</script>

<style>
@import "./assets/css/base.css";
@import "./assets/css/plugins.css";
</style>
